import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { exportPayrollRun, type PayrollExportFormat } from '@/services/payroll/payrollExportService';

interface ExportPayrollRunParams {
  runId: string;
  format: PayrollExportFormat;
  payslipIds?: string[];
}

export function usePayrollExport() {
  const { toast } = useToast();

  const exportMutation = useMutation({
    mutationFn: (params: ExportPayrollRunParams) =>
      exportPayrollRun(params.runId, params.format, params.payslipIds),
    onSuccess: (result, variables) => {
      toast({
        title: 'Export Complete',
        description: `Exported ${result.payslipCount} payslip(s) as ${variables.format.toUpperCase()}`,
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'Export Failed',
        description: error.message || 'Failed to export payroll data',
        variant: 'destructive',
      });
    },
  });

  return { exportRun: exportMutation };
}
